<div class="row cover-text" *ngIf="isMobile()" >
    <div *ngIf="isNotMobileMenu()" class="col-sm-3">  
        <div class="row right">
            <app-sidemenu></app-sidemenu>
        </div>
    </div>
 
    <div [ngClass]="{'col-sm-9':isNotMobileMenu(),'col-sm-12':!isNotMobileMenu()}">  
        <div class="vertical-class-text" style="padding-top: 0px; padding-bottom: 0px; padding-left: 5px; padding-right: 0px;">
            <div class="">
                <img style="border-radius: 25px;" class="dailyversecss" [src]='ImageURL()'>
            </div>
        </div>
    </div>   
</div>

<div class="row cover-text" *ngIf="!isMobile()">
    <div [ngClass]="{'col-sm-9':isNotMobileMenu(),'col-sm-12':!isNotMobileMenu()}">  
        <div class="vertical-class-text" style="padding-top: 0px; padding-bottom: 0px; padding-left: 5px; padding-right: 0px;">
            <div class="">
                <img style="border-radius: 25px;" class="dailyversecss" [src]='ImageURL()'>
            </div>
        </div>
    </div>   
</div>

<br>

<!-- Para Desktop -->
<div class="row cover-text" *ngIf="isNotMobileMenu()">
    <div *ngIf="isNotMobileMenu(); then redirected()">

    </div>
    <div [ngClass]="{'col-sm-3':isNotMobileMenu(),'col-sm-12':!isNotMobileMenu()}">  
        Tutorial de como crear acceso un directo para dispositivos iPhone
    </div>
    <div [ngClass]="{'col-sm-9':isNotMobileMenu(),'col-sm-12':!isNotMobileMenu()}">            
        <div class="youtube-video-container">
            <video width="838" height="470" [src]='VideoURLiPhone()' poster="/assets/img/Iphone.jpg" frameborder="0" allow="autoplay; fullscreen" controls controlsList="nodownload"></video>
        </div>
    </div>   
</div>
<br>
<div class="row cover-text" *ngIf="isNotMobileMenu()">
    <div [ngClass]="{'col-sm-3':isNotMobileMenu(),'col-sm-12':!isNotMobileMenu()}">  
        Tutorial de como crear acceso directo para Android
    </div>
    <div [ngClass]="{'col-sm-9':isNotMobileMenu(),'col-sm-12':!isNotMobileMenu()}">             
        <div class="youtube-video-container">
            <video width="838" height="470" [src]='VideoURLAndroid()' poster="/assets/img/Android.jpg" frameborder="0" allow="autoplay; fullscreen" controls controlsList="nodownload"></video>
        </div>
    </div>  
</div>

<!-- Para movil -->
<div class="row cover-text" *ngIf="!isNotMobileMenu()">
    <div class="col-sm-12 title">  
        <div class="title-border">iPhone</div>
    </div>
<div style="padding: 15px;"></div>
    <div class="col-sm-12 VideoBody">             
        <div class="youtube-video-container">
            <video width="838" height="470" [src]='VideoURLiPhone()' poster="/assets/img/Iphone.jpg" frameborder="0" allow="autoplay; fullscreen" controls controlsList="nodownload"></video>
        </div>
        <p style="padding: 15px;">
            Tutorial de como crear un acceso directo para dispositivos iPhone
        </p>
    </div>   
</div>
<br>
<div class="row cover-text" *ngIf="!isNotMobileMenu()">
    <div class="col-sm-12 title">  
        <div class="title-border">Android</div>
    </div>
<div style="padding: 15px;"></div>
    <div class="col-sm-12 VideoBody">             
        <div class="youtube-video-container">
            <video width="838" height="470" [src]='VideoURLAndroid()' frameborder="0" poster="/assets/img/Android.jpg" allow="autoplay; fullscreen" controls controlsList="nodownload"></video>
        </div>
        <p style="padding: 15px;">
            Tutorial de como crear un acceso directo para dispositivos Android
        </p>
    </div>   
</div>
<br>
